import * as React from 'react';
import { RefinementType, FacetFilter } from '@packages/common';
import { RefinementsContext } from '../RefinementsContext';

export const useFacetRefinements = (featureMapping: string): FacetFilter | null => {
  const { refinements } = React.useContext(RefinementsContext);
  const facetFilters = refinements[RefinementType.FACET_FILTERS];
  return facetFilters[featureMapping] ? facetFilters[featureMapping] : null;
};
